import React from "react";
import PropTypes from "prop-types";
import { Badge, Button } from "reactstrap";
import mixpanelService from "common/mixpanel-service";
import pageData from "common/page-data";
import CampaignGroupPropType from "../campaign-group-prop-type";
import getCampaignStatusColor from "./campaign-status-color";
import getCampaignStatusIcon from "./campaign-status-icon";

const propTypes = {
  campaignGroup: CampaignGroupPropType.isRequired,
  showSupport: PropTypes.bool
};

const defaultProps = {
  showSupport: true
};

const CampaignStatusHeader = ({ campaignGroup, showSupport }) => {
  const color = getCampaignStatusColor(campaignGroup.status, campaignGroup.status_category);
  const icon = getCampaignStatusIcon(campaignGroup.status, campaignGroup.status_category);

  const handleGetSupport = () => {
    mixpanelService.track("Campaign.GetSupport", {
      ...pageData.get("mixpanelData"),
      campaignId: campaignGroup.campaign_id,
      campaignType: campaignGroup.campaign_type
    });
    if (window.Intercom) {
      window.Intercom("show");
    } else {
      window.location.href = "https://www.adwerx.com/help-center";
    }
  };

  return (
    <div className="campaign-status-header mb-2">
      <h1 className="campaign-status-header__name mb-0">{campaignGroup.name}</h1>
      {campaignGroup.status_label && (
        <Badge className="campaign-status-header__status" color={color}>
          <i className={`fa ${icon} mr-1`} aria-hidden="true" />
          {campaignGroup.status_label}
        </Badge>
      )}
      {showSupport && (
        <Button
          color="primary"
          onClick={handleGetSupport}
          className="campaign-status-header__support btn-sharp"
        >
          <i className="fa fa-headphones" />
          <span className="ml-2 d-none d-sm-inline">Get Support</span>
        </Button>
      )}
    </div>
  );
};

CampaignStatusHeader.propTypes = propTypes;
CampaignStatusHeader.defaultProps = defaultProps;

export default CampaignStatusHeader;
